import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Prefix from '../components/public/Prefix.vue';
import LoginDoctor from '../components/public/LoginDoctor.vue';
import Recovery from '../components/public/Recovery.vue';
import Logout from '../components/Logout.vue';
import RegisterDoctor from '../components/public/RegisterDoctor.vue';

import BidBoxDoctor from '../components/doctor/BoxesOfrecer/Index.vue';

import  PatientCoords from '../components/doctor/PatientCoords.vue';


import NotFound from '../components/errors/404.vue';
import DoctorLayout from '../components/doctor/partials/Layout.vue';
import DashboardDoctor from '../components/doctor/Dashboard.vue';
import Agenda from '../components/doctor/Agenda/Index.vue';
import AgendaAdd from '../components/doctor/Agenda/Add.vue';
import AgendaDelete from '../components/doctor/Agenda/Delete.vue';
import ProfileDoctor from '../components/doctor/ProfileDoctor.vue';
import AskBoxDoctor from '../components/doctor/BoxesSolicitud/Index.vue';
import Plans from '../components/doctor/Plans.vue';
import Office from '../components/doctor/Office/Index.vue';
import OfficeAdd from '../components/doctor/Office/Add.vue';
import Schedule from '../components/doctor/Schedule/Index.vue';
import ScheduleDetail from '../components/doctor/Schedule/Detail.vue';
import ExtraHours from '../components/doctor/ExtraHours/Index.vue';
import ExtraHoursAdd from '../components/doctor/ExtraHours/Add.vue';
import Absence from '../components/doctor/Absence/Index.vue';
import AbsenceAdd from '../components/doctor/Absence/Add.vue';
import Tracking from '../components/doctor/Tracking.vue';
import Subordinate from '../components/doctor/Subordinate/Index.vue';
import ProfileSubordinate from '../components/doctor/Subordinate/Profile.vue';
import Bid from '../components/doctor/Bid/Index.vue';

import Validate from '../components/doctor/Validate.vue';
import BidAdd from '../components/doctor/Bid/Add.vue';
import Doctor from '../components/doctor/Subordinate/Doctor.vue';
import Demo from '../components/public/Demo.vue';
import { doctor } from '../config/api.js';
import { prefix } from '../config/api';

export default new VueRouter({
    mode: 'history', // disabled hastag "#" on routes
    routes: [
        {
            // only routes with countries
            path: '/:country',
            component: Prefix,
            children: [
                {
                    // Route register doctor
                    path: doctor.register,
                    name: 'register.doctor',
                    component: RegisterDoctor,
                    meta: {
                        name: 'Registro'
                    }
                },
                {
                    // Route register doctor
                    path: "bidbox",
                    name: 'bidbox',
                    component: BidBoxDoctor,
                    meta: {
                        name: 'Ofertar BOX'
                    }
                },
                {
                    // Route login doctor
                    path: '/',
                    name: 'login.doctor',
                    component: LoginDoctor,
                    meta: {
                        forVisitors: true,
                        name: 'Inicio Sesión'
                    }
                },
                {
                    // Route login doctor
                    path: 'recovery',
                    name: 'recovery.doctor',
                    component: Recovery,
                    meta: {
                        forVisitors: true,
                        name: 'Recuperar Contraseña'
                    }
                },
                {
                    // Route logout
                    path: 'logout',
                    name: 'logout',
                    component: Logout,
                    meta: {
                        requiresAuth: true,
                        name: 'Logout'
                    }
                },
                {
                    // Route demo
                    path: 'demo',
                    component: Demo,
                    name: 'demo',
                    meta: {
                        name: 'Demo'
                    }
                },
                {
                    // Route dashbaord - need authentication
                    path: '/',
                    name: 'dashboard.layout',
                    component: DoctorLayout,
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        // Route dashboard
                        { path: 'dashboard', name: 'Dashboard' ,component: DashboardDoctor, meta: { name: 'Dashboard' }},
                        // Route profile
                        { path: 'askbox', name:'askbox', component: AskBoxDoctor, meta: { name: 'Solicitar BOX' }},
                        
                        //route offer box 
                        { path: 'patients', name:'patientscoords', component: PatientCoords, meta: { name: 'Georeferencial' }},
                        //route offer b
                        { path: 'bidbox_internal', name:'bidbox_internal', component: BidBoxDoctor, meta: { name: 'Ofrecer BOX' }},
                        //route offer box 
                        { path: 'profile', name:'profile', component: ProfileDoctor, meta: { name: 'Mi Perfil' }},
                        // Route agenda
                        { path: 'agenda', component: Agenda, name:'Agenda', meta: { name: 'Mi Agenda' }},
                        // Route agenda add
                        { path: 'agenda/add', component: AgendaAdd, name:'AgendaAdd', meta: { name: 'Agregar Cita', return: 'Agenda' }},
                        // Route agenda delete
                        { path: 'agenda/delete', component: AgendaDelete, meta: { name: 'Eliminar Cita' }},
                        // Route plans
                        { path: 'plans', name: 'Plans', component: Plans, meta: { name: 'Planes' }},
                        // Route office
                        { path: 'office', component: Office, name: 'Office', meta: { name: 'Mis Consultas / BOX'}},
                        // Route office add
                        { path: 'office/add', component: OfficeAdd, name: 'OfficeAdd', meta: { name: 'Agregar Consulta', return: 'Office'}},
                        // Route schedule
                        { path: 'schedule', component: Schedule, name: 'Schedule', meta: { name: 'Mis Horarios'}},
                        // Route schedule detail by officeId
                        { path: 'schedule/detail/:officeId', component: ScheduleDetail, name: 'ScheduleDetail', meta: { name: 'Mis Horarios', return: 'Schedule'}},
                        // Route extra-hours
                        { path: 'extra-hours', component: ExtraHours, name: 'ExtraHours', meta: { name: 'Horas Extraordinarias'}},
                        // Route extra-hours add
                        { path: 'extra-hours/add', component: ExtraHoursAdd, name: 'ExtraHoursAdd', meta: { name: 'Hora Extraordinaria', return: 'ExtraHours'}},
                        // Route absence
                        { path: 'absence', component: Absence, name: 'Absence', meta: { name: 'Ausencias'}},
                        // Route absence add
                        { path: 'absence/add', component: AbsenceAdd, name: 'AbsenceAdd', meta: { name: 'Agregar Ausencia', return: 'Absence'}},
                        // Route tracking
                        { path: 'tracking', component: Tracking, name: 'Tracking', meta: { name: 'Seguimiento'}},
                        // Route subordinate
                        { path: 'subordinate', component: Subordinate, name: 'Subordinate', meta: { name: 'Usuarios'}},
                        // Route subordinate role
                        { path: 'subordinate/role', component: ProfileSubordinate, name: 'ProfileSubordinate', meta: { name: 'Roles'}},
                        // Route bid
                        { path: 'bid', component: Bid, name: 'Bid', meta: { name: 'Mis Ofertas'}},
                        // Route bid add
                        { path: 'bid/add', component: BidAdd, name: 'BidAdd', meta: { name: 'Agregar Oferta', return: 'Bid'}},


                        { path: 'validate/:bonusCode?', component: Validate, name: 'Validate', meta: { name: 'Validar Bono'}},
                    ]
                },
                {
                    // Route doctor for user subordinate
                    path: 'doctor',
                    component: Doctor,
                    name: 'Doctor',
                    meta: {
                        name: 'Seleccionar Prestador'
                    }
                },
                {
                    // Route 404
                    path: '*',
                    name: 'notfound',
                    component: NotFound,
                    meta: {
                        name: 'Not Found'
                    }
                }
            ],
            meta: {
                prefix: true
            }
        },
        {
            // redirect prefix "cl" by default
            path: '/',
            redirect: '/' + prefix[0]
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js